// Shop grid quick add: "+" opens a size panel over the photo; picking a size adds it to the bag.
(function () {
  function panelFor(el) {
    var card = el.closest('.card-wrapper');
    return card ? card.querySelector('.quick-size') : null;
  }

  function closeAll(except) {
    document.querySelectorAll('.quick-size:not([hidden])').forEach(function (panel) {
      if (panel === except) return;
      panel.hidden = true;
      var card = panel.closest('.card-wrapper');
      var toggle = card && card.querySelector('.quick-size__toggle');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
  }

  function refreshCart(sections) {
    if (!sections) return;
    var parser = new DOMParser();
    if (sections['cart-icon-bubble']) {
      var bubble = document.getElementById('cart-icon-bubble');
      var html = parser.parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
      if (bubble && html) bubble.innerHTML = html.innerHTML;
    }
    if (sections['cart-drawer']) {
      var drawer = document.getElementById('CartDrawer');
      var fresh = parser.parseFromString(sections['cart-drawer'], 'text/html').querySelector('#CartDrawer');
      if (drawer && fresh) drawer.innerHTML = fresh.innerHTML;
      var drawerEl = document.querySelector('cart-drawer');
      if (drawerEl) drawerEl.classList.remove('is-empty');
    }
  }

  function addToBag(option) {
    var panel = option.closest('.quick-size');
    var status = panel.querySelector('.quick-size__status');
    var buttons = panel.querySelectorAll('.quick-size__option');
    buttons.forEach(function (b) { b.dataset.wasDisabled = b.disabled ? '1' : ''; b.disabled = true; });
    option.classList.add('is-loading');
    status.textContent = 'Adding…';

    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(option.dataset.variantId), quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        if (data.status && data.status >= 400) throw new Error(data.description || data.message || 'Could not add');
        refreshCart(data.sections);
        status.textContent = 'Added ' + option.textContent.trim() + ' to bag';
        setTimeout(function () { closeAll(); status.textContent = ''; }, 1400);
      })
      .catch(function (error) {
        status.textContent = error.message || 'Could not add to bag';
      })
      .finally(function () {
        option.classList.remove('is-loading');
        buttons.forEach(function (b) { b.disabled = b.dataset.wasDisabled === '1'; });
      });
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('.quick-size__toggle');
    if (toggle) {
      event.preventDefault();
      event.stopPropagation();
      var panel = panelFor(toggle);
      if (!panel) return;
      var opening = panel.hidden;
      closeAll(panel);
      panel.hidden = !opening;
      toggle.setAttribute('aria-expanded', opening ? 'true' : 'false');
      if (opening) {
        var first = panel.querySelector('.quick-size__option:not([disabled])');
        if (first) first.focus({ preventScroll: true });
      }
      return;
    }

    var close = event.target.closest('.quick-size__close');
    if (close) {
      event.preventDefault();
      event.stopPropagation();
      closeAll();
      return;
    }

    var option = event.target.closest('.quick-size__option');
    if (option) {
      event.preventDefault();
      event.stopPropagation();
      if (!option.disabled) addToBag(option);
      return;
    }

    if (!event.target.closest('.quick-size')) closeAll();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAll();
  });
})();
